import http from '../http-common'
import { APIBaseFunctions, APIDataSliceObj, defaultAPILimit } from '@/components/Utility/APIBase'

export class Tournaments extends APIBaseFunctions {
  static TournamentRowsDataService = class {
    private static cachedTournamentRowsDataSliceObj: APIDataSliceObj = {
      slicemode: 0,
      start: 0,
      limit: defaultAPILimit,
      page: 0,
      pagesize: 0,
      totalcount: 0
    }

    static getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentRowsDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/raekkes?_sort=${sortingOrder}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
      }

      return http.get(`/raekkes?pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
    }

    static async asyncGetAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentRowsDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/raekkes?sort=${sortingOrder}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
      }

      return http.get(`/raekkes?pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
    }

    static get (id: string) {
      return http.get(`/raekkes/${id}?populate=*`)
    }

    static getCount () {
      return http.get('/raekkes/count')
    }

    static create (data: any) {
      return http.post('/raekkes', data)
    }

    static update (id: string, data: any) {
      return http.put(`/raekkes/${id}`, data)
    }

    static delete (id: string) {
      return http.delete(`/raekkes/${id}`)
    }

    static deleteAll () {
      return http.delete('/raekkes')
    }

    static findByTournamentRowStatus (status: boolean, sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      let sortingOrderParameter = ''
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentRowsDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        sortingOrderParameter = `&_sort=${sortingOrder}`
      }

      return http.get(`/raekkes?filters[raekke_status][$eq]=${status}${sortingOrderParameter}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
    }

    static findBySearchTerm (status: boolean, ignoreStatus: boolean, searchTerm: string, sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      let retVal
      let sortingOrderParameter = ''
      let priceSearchParameter = ''
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentRowsDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        sortingOrderParameter = `&sort=${sortingOrder}`
      }

      if (!isNaN(Number(searchTerm))) {
        priceSearchParameter = `&filters[$or][2][turneringskategori_id][turneringskategori_pris][$contains]=${searchTerm.trim()}`
      }

      if (ignoreStatus) {
        retVal = http.get(`/raekkes?filters[$or][0][raekke_navn][$contains]=${searchTerm.trim()}&filters[$or][1][turneringskategori_id][turneringskategori_navn][$contains]=${searchTerm.trim()}${priceSearchParameter}${sortingOrderParameter}&pagination[start]=${currentDataSliceObj.start}&pagination[limit]=100000` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
      } else {
        retVal = http.get(`/raekkes?filters[raekke_status]=${status}&filters[$or][0][raekke_navn][$contains]=${searchTerm.trim()}&filters[$or][1][turneringskategori_id][turneringskategori_navn][$contains]=${searchTerm.trim()}${priceSearchParameter}${sortingOrderParameter}&pagination[start]=${currentDataSliceObj.start}&pagination[limit]=100000` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
      }

      return retVal
    }
  }

  static TournamentCategoriesDataService = class {
    private static cachedTournamentCategoriesDataSliceObj: APIDataSliceObj = {
      slicemode: 0,
      start: 0,
      limit: defaultAPILimit,
      page: 0,
      pagesize: 0,
      totalcount: 0
    }

    static getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentCategoriesDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/turneringskategoris?sort=${sortingOrder}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
      }

      return http.get(`/turneringskategoris?pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=100000` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
    }

    static asyncGetAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentCategoriesDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/turneringskategoris?sort=${sortingOrder}&pagination[start]=${currentDataSliceObj.start}&pagination[limit]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
      }

      return http.get(`/turneringskategoris?pagination[start]=${currentDataSliceObj.start}&pagination[limit]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
    }

    static get (id: string) {
      return http.get(`/turneringskategoris/${id}`)
    }

    static getCount () {
      return http.get('/turneringskategoris/count')
    }

    static create (data: any) {
      return http.post('/turneringskategoris', data)
    }

    static update (id: string, data: any) {
      return http.put(`/turneringskategoris/${id}`, data)
    }

    static delete (id: string) {
      return http.delete(`/turneringskategoris/${id}`)
    }

    static deleteAll () {
      return http.delete('/turneringskategoris')
    }

    static findByTournamentCategoryStatus (status: boolean, sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      let sortingOrderParameter = ''
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentCategoriesDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        sortingOrderParameter = `&_sort=${sortingOrder}`
      }

      return http.get(`/turneringskategoris?filters[turneringskategori_status][$eq]=${status}${sortingOrderParameter}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
    }

    static findBySearchTerm (status: boolean, ignoreStatus: boolean, searchTerm: string, sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      let retVal
      let sortingOrderParameter = ''
      let priceSearchParameter = ''
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentCategoriesDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        sortingOrderParameter = `&_sort=${sortingOrder}`
      }

      if (!isNaN(Number(searchTerm))) {
        priceSearchParameter = `&_where[_or][1][turneringskategori_pris_contains]=${searchTerm.trim()}`
      }

      if (ignoreStatus) {
        retVal = http.get(`/turneringskategoris?filters[$or][0][turneringskategori_navn][$contains]=${searchTerm.trim()}${priceSearchParameter}${sortingOrderParameter}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
      } else {
        retVal = http.get(`/turneringskategoris?filters[turneringskategori_status][$eq]=${status}&filters[$or][0][turneringskategori_navn][$contains]=${searchTerm.trim()}${priceSearchParameter}${sortingOrderParameter}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
      }
      return retVal
    }
  }

  static TournamentMatchSchedulesDataService = class {
    private static cachedTournamentMatchSchedulesDataSliceObj: APIDataSliceObj = {
      slicemode: 0,
      start: 0,
      limit: defaultAPILimit,
      page: 0,
      pagesize: 0,
      totalcount: 0
    }

    static getAll (
      sortingOrder = '',
      dataSliceObj: APIDataSliceObj | null = null,
      extraParameter = ''
    ) {
      const currentDataSliceObj = Tournaments.processDataSliceObj(
        { cachedServicesDataSliceObj: this.cachedTournamentMatchSchedulesDataSliceObj },
        dataSliceObj
      )

      let url = '/kampprograms?'

      const populateParams = [
        'populate[raekke_id][populate]=*',
        'populate[kampprogram_hjemmehold][populate]=*',
        'populate[kampprogram_udehold][populate]=*',
        'populate[saeson_id][populate]=*',
        'populate[kampgodkendt_id][populate]=*'
      ]

      url += populateParams.join('&')

      url += `&pagination[page]=${currentDataSliceObj.page + 1}`
      url += `&pagination[pageSize]=${currentDataSliceObj.limit}`

      if (sortingOrder.length > 0) {
        url += `&sort=${encodeURIComponent(sortingOrder)}`
      }

      if (extraParameter.length > 0) {
        url += `&${extraParameter}`
      }

      return http.get(url)
    }

    static async asyncGetAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentMatchSchedulesDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/kampprograms?sort=${sortingOrder}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }

      return http.get(`/kampprograms?pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
    }

    static get (id: string) {
      return http.get(`/kampprograms/${id}`)
    }

    static getCount (extraCountParameter = '') {
      return http.get('/kampprograms/count' + (extraCountParameter.length > 0 ? `?${extraCountParameter}` : ''))
    }

    static create (data: any) {
      return http.post('/kampprograms', data)
    }

    static update (id: string, data: any) {
      return http.put(`/kampprograms/${id}`, data)
    }

    static delete (id: string) {
      return http.delete(`/kampprograms/${id}`)
    }

    static async asyncDelete (id: string) {
      return http.delete(`/kampprograms/${id}`)
    }

    static deleteAll () {
      return http.delete('/kampprograms')
    }

    static findBySearchTerm (searchTerm: string, sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      let sortingOrderParameter = ''
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentMatchSchedulesDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        sortingOrderParameter = `&_sort=${sortingOrder}`
      }

      const retVal = http.get(`/kampprograms?_where[_or][0][kampprogram_kampnr_contains]=${searchTerm.trim()}&_where[_or][1][kampprogram_hjemmehold.hold_holdnavn_contains]=${searchTerm.trim()}&_where[_or][2][kampprogram_udehold.hold_holdnavn_contains]=${searchTerm.trim()}&_where[_or][3][raekke_id.raekke_navn_contains]=${searchTerm.trim()}${sortingOrderParameter}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))

      return retVal
    }
  }

  static TournamentMatchSettlementDataService = class {
    private static cachedTournamentMatchSettlementDataSliceObj: APIDataSliceObj = {
      slicemode: 0,
      start: 0,
      limit: defaultAPILimit,
      page: 0,
      pagesize: 0,
      totalcount: 0
    }

    static getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentMatchSettlementDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/kampafviklings?_sort=${sortingOrder}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }

      return http.get(`/kampafviklings?pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
    }

    static async asyncGetAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentMatchSettlementDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/kampafviklings?_sort=${sortingOrder}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }

      return http.get(`/kampafviklings?pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
    }

    static get (id: string) {
      return http.get(`/kampafviklings/${id}`)
    }

    static getCount () {
      return http.get('/kampafviklings/count')
    }

    static create (data: any) {
      return http.post('/kampafviklings', data)
    }

    static update (id: string, data: any) {
      return http.put(`/kampafviklings/${id}`, data)
    }

    static delete (id: string) {
      return http.delete(`/kampafviklings/${id}`)
    }

    static deleteAll () {
      return http.delete('/kampafviklings')
    }
  }

  static TournamentMatchSettlementExtDataService = class {
    private static cachedTournamentMatchSettlementExtDataSliceObj: APIDataSliceObj = {
      slicemode: 0,
      start: 0,
      limit: defaultAPILimit,
      page: 0,
      pagesize: 0,
      totalcount: 0
    }

    static getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentMatchSettlementExtDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/kampafvikling-ekstras?_sort=${sortingOrder}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }

      return http.get(`/kampafvikling-ekstras?_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
    }

    static async asyncGetAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentMatchSettlementExtDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/kampafvikling-ekstras?_sort=${sortingOrder}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }

      return http.get(`/kampafvikling-ekstras?_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
    }

    static get (id: string) {
      return http.get(`/kampafvikling-ekstras/${id}`)
    }

    static getCount () {
      return http.get('/kampafvikling-ekstras/count')
    }

    static create (data: any) {
      return http.post('/kampafvikling-ekstras', data)
    }

    static update (id: string, data: any) {
      return http.put(`/kampafvikling-ekstras/${id}`, data)
    }

    static delete (id: string) {
      return http.delete(`/kampafvikling-ekstras/${id}`)
    }

    static deleteAll () {
      return http.delete('/kampafvikling-ekstras')
    }
  }

  static TournamentMatchDataService = class {
    private static cachedTournamentMatchDataSliceObj: APIDataSliceObj = {
      slicemode: 0,
      start: 0,
      limit: defaultAPILimit,
      page: 0,
      pagesize: 0,
      totalcount: 0
    }

    static getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentMatchDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/kamps?_sort=${sortingOrder}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }

      return http.get(`/kamps?_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
    }

    static get (id: string) {
      return http.get(`/kamps/${id}`)
    }

    static getCount () {
      return http.get('/kamps/count')
    }

    static create (data: any) {
      return http.post('/kamps', data)
    }

    static update (id: string, data: any) {
      return http.put(`/kamps/${id}`, data)
    }

    static delete (id: string) {
      return http.delete(`/kamps/${id}`)
    }

    static deleteAll () {
      return http.delete('/kamps')
    }
  }

  static TournamentMatchSetDataService = class {
    private static cachedTournamentMatchSetDataSliceObj: APIDataSliceObj = {
      slicemode: 0,
      start: 0,
      limit: defaultAPILimit,
      page: 0,
      pagesize: 0,
      totalcount: 0
    }

    static getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentMatchSetDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/kamp-saets?_sort=${sortingOrder}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }

      return http.get(`/kamp-saets?_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
    }

    static get (id: string) {
      return http.get(`/kamp-saets/${id}`)
    }

    static getCount () {
      return http.get('/kamp-saets/count')
    }

    static create (data: any) {
      console.log('[TournamentMatchSetDataService.create] data = ' + JSON.stringify(data))
      return http.post('/kamp-saets', data)
    }

    static update (id: string, data: any) {
      return http.put(`/kamp-saets/${id}`, data)
    }

    static delete (id: string) {
      return http.delete(`/kamp-saets/${id}`)
    }

    static deleteAll () {
      return http.delete('/kamp-saets')
    }
  }

  static TournamentMatch180DataService = class {
    private static cachedTournamentMatch180DataSliceObj: APIDataSliceObj = {
      slicemode: 0,
      start: 0,
      limit: defaultAPILimit,
      page: 0,
      pagesize: 0,
      totalcount: 0
    }

    static getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentMatch180DataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/kamp-180-s?_sort=${sortingOrder}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }

      return http.get(`/kamp-180-s?_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
    }

    static get (id: string) {
      return http.get(`/kamp-180-s/${id}`)
    }

    static getCount () {
      return http.get('/kamp-180-s/count')
    }

    static create (data: any) {
      return http.post('/kamp-180-s', data)
    }

    static update (id: string, data: any) {
      return http.put(`/kamp-180-s/${id}`, data)
    }

    static delete (id: string) {
      return http.delete(`/kamp-180-s/${id}`)
    }

    static deleteAll () {
      return http.delete('/kamp-180-s')
    }
  }

  static TournamentRoundsDataService = class {
    private static cachedTournamentRoundsDataSliceObj: APIDataSliceObj = {
      slicemode: 0,
      start: 0,
      limit: defaultAPILimit,
      page: 0,
      pagesize: 0,
      totalcount: 0
    }

    static getAll (
      sortingOrder = '',
      dataSliceObj: APIDataSliceObj | null = null,
      extraParameter = ''
    ) {
      const currentDataSliceObj = Tournaments.processDataSliceObj(
        { cachedServicesDataSliceObj: this.cachedTournamentRoundsDataSliceObj },
        dataSliceObj
      )

      const params: Record<string, any> = {}

      params['pagination[start]'] = currentDataSliceObj.start
      params['pagination[limit]'] = currentDataSliceObj.limit

      if (sortingOrder.length > 0) {
        params['sort[0]'] = sortingOrder
      }

      let extraParams = ''
      if (extraParameter.length > 0) {
        extraParams = `&${extraParameter}`
      }

      const queryString = Object.entries(params)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&')

      return http.get(`/turneringsrunders?${queryString}${extraParams}&populate=*`)
    }

    static get (id: string) {
      return http.get(`/turneringsrunders/${id}`)
    }

    static getCount () {
      return http.get('/turneringsrunders/count')
    }

    static create (data: any) {
      return http.post('/turneringsrunders', data)
    }

    static update (id: string, data: any) {
      return http.put(`/turneringsrunders/${id}`, data)
    }

    static delete (id: string) {
      return http.delete(`/turneringsrunders/${id}`)
    }

    static deleteAll () {
      return http.delete('/turneringsrunders')
    }
  }

  static TournamentRulesDataService = class {
    private static cachedTournamentRulesDataSliceObj: APIDataSliceObj = {
      slicemode: 0,
      start: 0,
      limit: defaultAPILimit,
      page: 0,
      pagesize: 0,
      totalcount: 0
    }

    static getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentRulesDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/turneringsreglers?${sortingOrder}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=100000` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
      }

      return http.get(`/turneringsreglers?pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=100000` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
    }

    static get (id: string) {
      return http.get(`/turneringsreglers/${id}?populate=*`)
    }

    static getCount (extraCountParameter = '') {
      return http.get('/turneringsreglers/count' + (extraCountParameter.length > 0 ? `?${extraCountParameter}` : ''))
    }

    static create (data: any) {
      return http.post('/turneringsreglers', data)
    }

    static update (id: string, data: any) {
      return http.put(`/turneringsreglers/${id}`, data)
    }

    static delete (id: string) {
      return http.delete(`/turneringsreglers/${id}`)
    }

    static deleteAll () {
      return http.delete('/turneringsreglers')
    }
  }

  static TournamentMatchFinalApproval = class {
    private static cachedTournamentMatchFinishedSliceObj: APIDataSliceObj = {
      slicemode: 0,
      start: 0,
      limit: defaultAPILimit,
      page: 0,
      pagesize: 0,
      totalcount: 0
    }

    static getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentMatchFinishedSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/kampgodkendts?_sort${sortingOrder}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }

      return http.get(`/kampgodkendts?_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
    }

    static get (id: string) {
      return http.get(`/kampgodkendts/${id}`)
    }

    static getCount (extraCountParameter = '') {
      return http.get('/kampgodkendts/count' + (extraCountParameter.length > 0 ? `?${extraCountParameter}` : ''))
    }

    static create (data: any) {
      return http.post('/kampgodkendts', data)
    }

    static update (id: string, data: any) {
      return http.put(`/kampgodkendts/${id}`, data)
    }

    static delete (id: string) {
      return http.delete(`/kampgodkendts/${id}`)
    }

    static deleteAll () {
      return http.delete('/kampgodkendts')
    }
  }

  static TournamentMatchesTeamRankingsDataService = class {
    private static cachedTournamentMatchesTeamRankingsSliceObj: APIDataSliceObj = {
      slicemode: 0,
      start: 0,
      limit: defaultAPILimit,
      page: 0,
      pagesize: 0,
      totalcount: 0
    }

    static getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentMatchesTeamRankingsSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/stillingers?_sort${sortingOrder}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }

      return http.get(`/stillingers?_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
    }

    static async asyncGetAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null, extraParameter = '') {
      const currentDataSliceObj = Tournaments.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTournamentMatchesTeamRankingsSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/stillingers?_sort${sortingOrder}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }

      return http.get(`/stillingers?_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
    }

    static get (id: string) {
      return http.get(`/stillingers/${id}`)
    }

    static getCount (extraCountParameter = '') {
      return http.get('/stillingers/count' + (extraCountParameter.length > 0 ? `?${extraCountParameter}` : ''))
    }

    static create (data: any) {
      return http.post('/stillingers', data)
    }

    static async asyncCreate (data: any) {
      return http.post('/stillingers', data)
    }

    static update (id: string, data: any) {
      return http.put(`/stillingers/${id}`, data)
    }
  }
}

export default new Tournaments()
